export var SUSHISWAP_ROUTER_ADDRESS = {
    '1': '0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F',
    '42161': '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
    '10': '',
    '8453': '0x6BDED42c6DA8FBf0d2bA55B2fa120C5e0c8D7891',
    '11155111': '',
};
export var ROUTER_ADDRESSES = [
    { address: SUSHISWAP_ROUTER_ADDRESS['1'], chainId: 1 },
    { address: SUSHISWAP_ROUTER_ADDRESS['10'], chainId: 10 },
    { address: SUSHISWAP_ROUTER_ADDRESS['42161'], chainId: 42161 },
    { address: SUSHISWAP_ROUTER_ADDRESS['8453'], chainId: 8453 },
    { address: SUSHISWAP_ROUTER_ADDRESS['11155111'], chainId: 11155111 },
];
